import React from 'react';
import { dailyGratitudeContent } from '../rich-content/daily-gratitude-complete-content';
import { AutomaticPageBuilder } from '../page-sections/automatic-page-builder';

const DailyGratitudeDetailPage = () => {
  return <AutomaticPageBuilder content={dailyGratitudeContent} />;
};

export default DailyGratitudeDetailPage;
